import {EmbeddedPendingComponent} from "~/components/routerHelpers/embeddedPendingComponent";
import {Route} from "./route";

export function PendingComponent() {
    return (
        <EmbeddedPendingComponent
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            route={Route as any}
        //
        />
    );
}
